import { GrafanaEvents } from '../grafana';
import { MixpanelEvents } from '../mixpanel';
import { sendMixpanel } from '../mixpanel/reporter';
import { metric } from '../../../lib/metric';

export const DEFAULT_REPORTED_CHANNELS = [
    {
        name: 'grafana',
        events: GrafanaEvents,
        reporter: metric.count,
    },
    {
        name: 'mixpanel',
        events: MixpanelEvents,
        reporter: sendMixpanel,
    },
];
